import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';
import { useSessionContext } from '@/contexts/SessionContext';

export const usePostActivity = (postId: string) => {
  const { user } = useAuth();
  const { sessionKey } = useSessionContext();
  const [newCommentCount, setNewCommentCount] = useState(0);
  const [hasNewActivity, setHasNewActivity] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivity = async () => {
      // Skip fetch if no postId (used in list view with pre-fetched metrics)
      if (!postId) {
        setLoading(false);
        return;
      }

      if (!user) {
        setNewCommentCount(0);
        setHasNewActivity(false);
        setLoading(false);
        return;
      }
      
      try {
        const { data, error } = await supabase.rpc('get_post_activity_status', {
          post_id: postId,
          user_id_param: user?.id || null,
          session_key_param: sessionKey || null
        });
        
        if (error) throw error;
        
        if (data && data.length > 0) {
          setNewCommentCount(Number(data[0].new_comment_count) || 0);
          setHasNewActivity(data[0].has_new_activity || false);
        }
      } catch (error: any) {
        console.error('Error fetching post activity:', error);
      } finally {
        setLoading(false);
      }
    };
    
    if (postId) {
      fetchActivity();
    } else {
      setLoading(false);
    }
  }, [postId, user?.id, sessionKey]);

  return { newCommentCount, hasNewActivity, loading };
};
